import { z } from '@bonanza-social/toolkit/api';

export const CustomerTokenSchema = z.object({
  accessToken: z.string(),
  creationDate: z.number(),
  entityId: z.string(),
  expiresIn: z.number(),
  licenseId: z.number(),
  tokenType: z.string(),
});

export const SessionVariablesSchema = z.object({});
